<template>
  <f7-page name="ccm-course-dashboard" class="page-bg-render">
    <f7-navbar>
			<f7-nav-left>   
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">{{getCourseName()}}</div>
			<f7-nav-right>
        <f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block-title>
			<span class="text-color-red vertical-align-middle"><i class="f7-icons">alarm_fill</i></span>
			<span class="vertical-align-middle">오늘의 숙제</span>
			<span class="badge color-primary vertical-align-middle" v-if="homeworkList.length > 0">{{homeworkList.length}}</span>
		</f7-block-title>
		<div class="list">
			<ul>
				<li v-for="(item,i) in homeworkList" :key="'i'+i">
					<a href="#" class="item-link" v-on:click="startHomeWork(i);">
						<div class="item-content item-inner">
							<div class="item-title">
								<div class="item-header">{{getHomeworkContentInfo(i)}}</div>
								{{item.STUDY_NAME}} ({{item.TOTAL_ITEM_CNT}} 문제)
							</div>
							<div class="item-after">
								<span class="badge color-orange" v-if="item.RESULT_STATUS == 'puted'">숙제하기</span>
								<span class="badge color-gray" v-else>결과보기</span>
							</div>
						</div>
					</a>
				</li>			
			</ul>
		</div>


		<f7-block-title>
			<span class="text-color-red vertical-align-middle"><i class="f7-icons">equal_square_fill</i></span>
			<span class="vertical-align-middle">오늘의 유형학습</span>
			<span class="badge color-primary vertical-align-middle" v-if="patStudyList.length > 0" >{{patStudyList.length}} </span>
		</f7-block-title>
		<div class="list">
			<ul>
				<li v-for="(item,i) in patStudyList" :key="'i'+i" >
					<a href="#" class="item-link" v-on:click="startStudyPat(i);">
						<div class="item-content item-inner">
							<div class="item-title">
								<div class="item-header">유형 단원 : {{item.CL_NAME}}</div>
								{{item.PAT_NAME}} 
							</div>
							<div class="item-after" >
								<!--
								<img :src="'static/unit/lv'+item.UNIT_CONQUER+'.png'" v-if="item.UNIT_CONQUER > 0"/>
								<img :src="'static/unit/lv0.png'" v-else/>
								-->
							</div>
						</div>
					</a>
				</li>			
			</ul>
		</div>


		<f7-block-title>
			<span class="text-color-red vertical-align-middle"><i class="f7-icons">doc_richtext</i></span>
			<span class="vertical-align-middle">담임 선생님 문제지(최근 2주)</span>
			<span class="badge color-primary vertical-align-middle" v-if="examSetList.length > 0" >{{examSetList.length}} </span>
		</f7-block-title>
		<div class="list">
			<ul>
				<li v-for="(item,i) in examSetList" :key="'i'+i">
					<a href="#" class="item-link" v-on:click="startStudyExamSet(i);">
						<div class="item-content item-inner">
							<div class="item-title">
								<div class="item-header">문제지: {{getExamSetCode(i)}}</div>
								{{item.EXAMSET_NAME}} ({{item.EXAM_COUNT}} 문제)
							</div>
							<div class="item-after">		
								<span class="badge color-gray" v-if="item.RESULT_STATUS == 1">다시풀기</span>		
								<span class="badge color-orange" v-else>문제풀이</span>														
							</div>
						</div>	
					</a>
				</li>		
			</ul>
		</div>
  </f7-page>
</template>

<script>
import MODULE from '../../../js/common/module';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js'
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
  data() {
    return {
			gradeId: "-",
			reviseId: "-",
			semesterId: "-",

			homeworkList: [],
			patStudyList: [],
			examSetList: []
    }
  },
  mounted() {
		var _this = this;

		_this.gradeId = _this.$f7route.context.gradeId;
		_this.semesterId = _this.$f7route.context.semesterId;
		_this.reviseId = _this.$f7route.context.reviseId;

		_this.loadCourseDashBoard();

    // $(document).on('page:init page:reinit', '.page[data-name="ccm-course-dashboard"]', this.onPageShow);
  },
  methods: {
		onPageShow() {
			
		},
		loadCourseDashBoard() {
			var _this = this;

			let param = {
				pGradeId: _this.gradeId,
				pReviseId: _this.reviseId,
				pSemesterId: _this.semesterId
			};

			API.ajaxRequest({
				url: API.getCourseDashBoardUrl(),
				data: param
			}).then(function (data) {
				_this.homeworkList = data.homeworkList;
				_this.patStudyList = data.patStudyList;
				_this.examSetList = data.examSetList;
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
    getCourseName() {
			var _this = this;
			var courseId = _this.gradeId + _this.semesterId;
			var courseName = CONST.courseMap[courseId].name;
	
			return courseName + "(" + _this.reviseId + "개정)";  
		},
		getHomeworkContentInfo(itemIndex) {
			var _this = this;
			var item = _this.homeworkList[itemIndex];

			if (item.STUDY_TYPE == "mb-put") {
				return "매칭북 숙제 : " + MODULE.Util.keyToCode(CONST.matchBookCodePrefix, item.CONTENT_KEY);
			} else if (item.STUDY_TYPE == "exam-put") {
				return "문제지 숙제 : " + MODULE.Util.keyToCode(CONST.examSetCodePrefix, item.CONTENT_KEY);
			} else if (item.STUDY_TYPE == "pat-put") {
				return "유형학습 숙제";
			} else if (item.STUDY_TYPE == "mp-put") {
				return "매칭기출 숙제 : " + MODULE.Util.keyToCode(CONST.matchPaperCodePrefix, item.CONTENT_KEY);
			} else if (item.STUDY_TYPE == "sb-put") {
				return "스마트북 숙제 : " + MODULE.Util.keyToCode(CONST.smartBookCodePrefix, item.CONTENT_KEY);
			} else if (item.STUDY_TYPE == "le-put") {
				return "강의듣기 숙제 : " + MODULE.Util.keyToCode(CONST.matchBookCodePrefix, item.CONTENT_KEY);
			}
		},   
		getExamSetCode(itemIndex) {			
			var _this = this;
			var item = _this.examSetList[itemIndex];
		  var examSetCode = MODULE.Util.keyToCode(CONST.examSetCodePrefix, item.EXAMSET_KEY);
		
			return examSetCode;
		},
		startHomeWork(itemIndex) {
			var _this = this;
			var item = _this.homeworkList[itemIndex];
			var url = "";
			var code = "";
			var param = undefined;
			
			if (item.STUDY_TYPE == "mb-put") {
				url = PAGES.SUB_CCM_MATCHBOOK_APPLY;
				code = MODULE.Util.keyToCode(CONST.matchBookCodePrefix, item.CONTENT_KEY);
			} else if (item.STUDY_TYPE == "exam-put") {
				url = PAGES.SUB_CCM_EXAMSET_APPLY;
				code = MODULE.Util.keyToCode(CONST.examSetCodePrefix, item.CONTENT_KEY);
			} else if (item.STUDY_TYPE == "pat-put") {
				//
			} else if (item.STUDY_TYPE == "mp-put") {
				url = PAGES.SUB_CCM_MATCHPAPER_APPLY;
				code = MODULE.Util.keyToCode(CONST.matchPaperCodePrefix, item.CONTENT_KEY);
			} else if (item.STUDY_TYPE == "sb-put") {
				//
			} else if (item.STUDY_TYPE == "le-put") {
				//
			}

			if(item.RESULT_STATUS == 'puted') {
				
				param = {
					studyType: item.STUDY_TYPE, 
					code: code,                  
					studyKey: item.STUDY_KEY,
					startPageNo: item.SUB_P1,
					endPageNo: item.SUB_P2,
					startExamNo: item.SUB_E1,
					endExamNo: item.SUB_E2
				}

			}else {

				param = {
					studyType: item.STUDY_TYPE, 
					studyResultKey: item.RESULT_KEY,
					code: code,                  
					studyKey: item.STUDY_KEY,
					startPageNo: item.SUB_P1,
					endPageNo: item.SUB_P2,
					startExamNo: item.SUB_E1,
					endExamNo: item.SUB_E2
				}
				
			}						
			PAGES.popPage(url, param);	
		},
		startStudyPat(itemIndex) {
			var _this = this;
			var item = _this.patStudyList[itemIndex];
			var array = [];

			array.push(item.PAT_KEY);

			var url = PAGES.SUB_CCM_PAT_CONQUER_APPLY;
			var param = {
				sunitKey: item.SUNIT_KEY,
				patArray: array
			}
			
			PAGES.popPage(url,param);
		},
		startStudyExamSet(itemIndex) {
			var _this = this;
			var item = _this.examSetList[itemIndex];
			var url = PAGES.SUB_CCM_EXAMSET_APPLY;

			var param = {
					studyType: CONST.studyType["exam-sdy"].id, 
					examSetKey: item.EXAMSET_KEY,                  
					studyKey: item.STUDY_KEY			
			};

			PAGES.popPage(url, param);
		}
	
	
  }
}

</script>